import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, switchMap, take, tap } from 'rxjs';
import { isPlatformBrowser, Location } from '@angular/common';
import { AppState, selectPermissions } from '../ngrx/app.state';
import { AlertService } from '../services/alert.service';

export const PermissionGuard: CanActivateFn = (route, state) => {
  const store: Store<AppState> = inject(Store<AppState>);
  const alertService: AlertService = inject(AlertService);
  const location: Location = inject(Location);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  return store.select(selectPermissions).pipe(switchMap((permissions: string[] | undefined) => {
    let includesOne = false;
    if (route.data && route.data['requireOneOf']) {
      for (let permission of route.data['requireOneOf']) {
        for (let userPermission of permissions || []) {
          if (permission === userPermission) {
            includesOne = true;
          }
        }
      }
    }
    return of(includesOne).pipe(tap((includesOne) => {
      if (!includesOne && isBrowser) {
        let snackBar = alertService.showSnackBar("You do not have permission to access the requested resource. Dismiss to go back.");
        snackBar.afterDismissed().pipe(take(1)).subscribe(() => {
          if (isBrowser) {
            of(location.back()); 
          }
        });
      }
    }));
  }));
};
